<template>
  <div>
    <el-table v-loading="isLoading" :data="searchTable">
      <el-table-column 
        v-for="(item, index) in columnList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :sortable="item.sortable"
      />
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    searchTable: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      columnList: [
          { label: '日期', prop: 'accountPeriod', sortable: true},
          { label: '城市', prop: 'regionName'},
          { label: '不含税实收流水', prop: 'noTaxActuallyMoney'},
        ]
    }
  }
}
</script>
